import React from 'react'
import DateComp from '../../../../core/common/dateComponent/DateComp'

const SummaryWizardContact = ({ formik, formikSource, formikAppointment, formikContactOpportunity }: any) => {

  return (
    <>
      <div className='br-gray p-2 mt-3'>
        <h5 className='mb-1 color-red'>Contact:</h5>
        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  Primary Contact :
                </p>
                <p className='mb-0'>
                  Email Address :
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0'>
                  {formik?.values?.primaryContact?.salutation?.value}
                  {' '}
                  {formik?.values?.primaryContact?.firstName}
                  {' '}
                  {formik?.values?.primaryContact?.lastName}
                </p>
                <p>
                  {formik?.values?.primaryContact?.homeEmail}
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  Cell Phone :
                </p>
                <p className='mb-0'>
                  Home Phone :
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0'>
                  {formik?.values?.primaryContact?.cellPhone}
                </p>
                <p className='mb-0'>
                  {formik?.values?.primaryContact?.homePhone}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='br-gray p-2 mt-3'>
        <h5 className='mb-1 color-red'>Addresses:</h5>
        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  Property Address :
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0 w-100'>
                  {formik?.values?.primaryContact?.propertyAddress?.addressLine1}
                </p>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  City :
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0'>
                  {formik?.values?.primaryContact?.propertyAddress?.cityName}
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  Mailing Address :
                </p>
              </div>
              <div className='col-md-8'>
                <div className='mb-0'>
                  {formik?.values?.primaryContact?.mailingAddress?.addressLine1}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  City :
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0'>
                  {formik?.values?.primaryContact?.mailingAddress?.cityName}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='br-gray p-2 mt-3'>
        <div className='row'>
          <div className='col-md-6'>
            <h5 className='mb-1 color-red'>Opportunity Details:</h5>
            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Job Type :
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0 w-100'>
                  {formikContactOpportunity?.values?.opportunityDetailsDescription?.jobType?.value}
                </p>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Description:
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0'>
                  {formikContactOpportunity?.values?.opportunityDetailsDescription?.description}

                </p>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <h5 className='mb-1 color-red'>Appointment:</h5>

            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Apt Date
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0 w-100'>
                  <DateComp formattedDate={formikAppointment?.values?.startDate} />
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Apt Time
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0'>
                  {formikAppointment?.values?.startTime}
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Apt Maker
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0'>
                  {formikAppointment?.values?.internalAttendees[0]?.value}
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Apt Location
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0'>
                  {formikAppointment?.values?.lst_FreshAptLocation?.value}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='br-gray p-2 mt-3'>
        <h5 className='mb-1 color-red'>Source:</h5>
        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  1st Contract Date :
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0 w-100'>
                <DateComp formattedDate= {formikSource?.values?.firstContactDate}/>
                </p>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-4'>
                <p className='mb-0'>
                  Inquiry Method:
                </p>
              </div>
              <div className='col-md-8'>
                <p className='mb-0'>
                  {formikSource?.values?.lst_MethodOfInquiry?.value}

                </p>
              </div>
            </div>

          </div>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-6'>
                <p className='mb-0'>
                  Lead Source Category :
                </p>
              </div>
              <div className='col-md-6'>
                <p className='mb-0 w-100'>
                  {formikSource?.values?.lst_LeadSourceCategory?.value}
                </p>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-6'>
                <p className='mb-0'>
                  Lead Source:
                </p>
              </div>
              <div className='col-md-6'>
                <p className='mb-0'>
                  {formikSource?.values?.lst_LeadSource?.value}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='br-gray p-2 mt-3'>
        <h5 className='mb-1 color-red'>Notes:</h5>
        <div className='row'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  Internal Notes :
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0 w-100'>
                  {formik?.values?.internalComments}
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <p className='mb-0'>
                  External Notes:
                </p>
              </div>
              <div className='col-md-9'>
                <p className='mb-0'>
                  {formik?.values?.externalComments}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SummaryWizardContact